import apiProtected from '@lib/api/apiClient';
import { server } from '@lib/api/http';
import { useMutation } from '@tanstack/react-query';

export const useChargeSavedCardMutation = () => {
  return useMutation({
    mutationFn: (input: { token: string; amount: unknown; jobData: unknown }) =>
      apiProtected.post(`${server}v1/braintree/charge-user-with-token`, input),
  });
};

export const useChargeCardMutation = () => {
  return useMutation({
    mutationFn: (input: { nonce: string; amount: unknown; jobData: unknown }) =>
      apiProtected.post(`${server}v1/braintree/charge-user`, input),
  });
};
